import React from "react";
import {useMutation, useQueryClient} from "react-query";
import ApiClient from "../../../../common/API";
import {toast} from "react-toastify";
import Button from "@mui/material/Button";
import {useUserList} from "../../../../common/API/hooks";
import LoadingComponent from "../../../../common/components/LoadingComponent";
import DataSourceAsModalButton from "./DataSources/DataSourceAsModalButton";

const cleanDataSource = dataSource => {
    return {
        table: dataSource.table,
        columns: dataSource.columns
    }
}

export default function UpdateDashboard({dashboard}) {
    const queryClient = useQueryClient()
    const {data: userList, isLoading: isLoadingUserList} = useUserList({}, {})
    const record = dashboard.db

    const commonDashboardMutation = useMutation((dashboardData) => {
        const patchPromise = ApiClient().patch(`dashboard/common-dashboard/${record.id}/`, dashboardData)
        toast.promise(patchPromise, {
            loading: 'Updating...',
            success: `Dashboard "${dashboardData.name}" updated!`,
            error: `Error updating dashboard "${dashboardData.name}"`,
        })
        return patchPromise.then((res) => res.data)
    }, {
        onSuccess: () => {
            return queryClient.invalidateQueries(["dashboard", "dashboard_lists"])
        }
    })

    const userEmailToId = userList?.reduce((acc, user) => {
        acc[user.email.toLowerCase()] = user.id
        return acc
    }, {})


    const ownerIds = (userEmailToId && dashboard.owners) ?
        dashboard.owners?.map(ownerEmail => {
            return userEmailToId[ownerEmail.toLowerCase()]
        }) :
        []


    const prepareDashboard = () => {
        const dashboardApiData = {
            name: dashboard.name,
            path: dashboard.path,
            data_sources: dashboard.data_sources?.map(cleanDataSource) || []
        }

        // update the dashboard in common dashboard storage
        commonDashboardMutation.mutateAsync(dashboardApiData).then(() => {
            toast.info(<div>
                Dashboard had been updated. <DataSourceAsModalButton dataSources={dashboard.data_sources}/>
            </div>, {
                autoClose: false,
                closeOnClick: false
            })
        })
    }

    const isDifferent = () => {
        if (!record) return false

        const nameDiff = dashboard.name !== record.name
        const pathDiff = dashboard.path !== record.path

        const currentOwnerIds = [...(ownerIds || [])].sort()
        const recordOwnerIds = [...(record.owner_ids || [])].sort()
        const ownerIdsDiff = JSON.stringify(currentOwnerIds) !== JSON.stringify(recordOwnerIds)

        const preparedDataSources = dashboard.data_sources?.map(cleanDataSource) || []
        const dataSourcesDiff = JSON.stringify(preparedDataSources) !== JSON.stringify(record.data_sources || [])

        return nameDiff || pathDiff || ownerIdsDiff || dataSourcesDiff
    }

    if (isLoadingUserList) {
        return <LoadingComponent/>
    }

    if (!isDifferent()) {
        return null
    }

    return (
        <Button onClick={prepareDashboard} variant="outlined" size="small">
            UPDATE
        </Button>
    )
}
